module.exports = __webpack_public_path__ + "static/img/7.7b321e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/sp/7.png
// module id = Kqov
// module chunks = 0